export default {
    name: 'imageuploadservice',
    dependencies: ['xhrservice', 'sitesettings'],
    callable(xhrservice, siteSettings) {
        const uploadUrl = `${siteSettings.wwwSite}/upload/file/images/`;

        function uploadImage(key, loginId, file) {
            const formData = new FormData();
            formData.append('files', file);
            formData.append('referencesCSV', '1');
            formData.append('rotateByExif', true);
            formData.append('cropToSquare', true);

            return new Promise((resolve, reject) => {
                const request = new XMLHttpRequest();

                request.onload = function() {
                    if (request.status === 200) {
                        let resolved = false;
                        if (request.response) {
                            const result = JSON.parse(request.response);
                            if (result.xhr) {
                                // The image upload module double encodes for some reason
                                const actualResult = JSON.parse(result.xhr);
                                if (
                                    actualResult.uploads &&
                                    actualResult.uploads.length > 0
                                ) {
                                    resolve(actualResult.uploads[0].url);
                                    resolved = true;
                                }
                            }
                        }

                        if (!resolved) {
                            reject('Unexpected response from image upload');
                        }
                    } else {
                        reject(
                            'Image upload server did not respond with success'
                        );
                    }
                };

                request.onerror = function() {
                    reject('Image upload failed');
                };

                const url = `${uploadUrl + key}/${loginId}`;
                request.open('POST', url, true);
                request.withCredentials = true;
                request.setRequestHeader('Accept', 'application/json');
                request.send(formData);
            });
        }

        function removeImage(key, loginId, imagePath) {
            return xhrservice
                .request({
                    url: `${uploadUrl + key}/${loginId}/remove.json`,
                    method: 'POST',
                    data: {
                        imagePath,
                    },
                })
                .then(result => {
                    if (result.error) {
                        throw result.error;
                    }
                });
        }

        return {
            uploadImage,
            removeImage,
        };
    },
};



// WEBPACK FOOTER //
// ./services/imageuploadservice.js